import {WlCheckboxGroup} from "./checkboxGroup.component";

export * from './checkboxGroup.component';
export default WlCheckboxGroup;

customElements.define('wl-checkbox-group', WlCheckboxGroup);
